import * as yup from 'yup';
import { RecipeIngredientsList } from '../../components';
import { schema as recipeIngredient } from './recipe_ingredient';
import { schema as ingredientsModal } from './full_ingredients_modal';

export const component = RecipeIngredientsList;

export const schema = yup
  .object({
    value: yup.string().required(),
    label: yup.string().required(),
    ingredients: yup.array(recipeIngredient).required(),
    modal: ingredientsModal,
  })
  .from('display_name', 'label')
  .from('slug', 'value');
